import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

const SeoTitleUpdater = ({ section = null, locationName = null }) => {
  const tags = document.title.split(' | ').filter(Boolean);

  const getTitle = () => {
    if (section && !tags.includes(section)) {
      tags.push(section);
    }

    if (locationName && !tags.includes(locationName)) {
      tags.push(locationName);
    }

    return tags.filter(Boolean).join(' | ');
  };

  return (
    <Helmet>
      <title>{getTitle()}</title>
    </Helmet>
  );
};

SeoTitleUpdater.propTypes = {
  section: PropTypes.string,
  locationName: PropTypes.string
};

export default SeoTitleUpdater;
